const Airtable = require('airtable');
const dataApi = new Airtable({apiKey: 'key7c24Of5GZOahhf'}).base('appADB0o3dhu26pSZ');

export default dataApi;
